import { type FlowExportToSftpBlockConfig, FlowExportToSftpBlockConfigSchema } from 'flow-schema';

import { ExportToSftpFormFields } from './FormFields';
import { exportToSftpDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const exportToSftpConfig: BlockConfigProps<FlowExportToSftpBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'exportToSftp',
  defaultConfig: {
    fileReference: '',
    directory: '',
    filename: '',
    onCollision: 'Overwrite',
  },
  configFields: {
    schema: FlowExportToSftpBlockConfigSchema,
    FormFields: ExportToSftpFormFields,
  },
  documentationMarkdown: exportToSftpDocumentationMarkdown,
};
